import utils from '@/plugins/TravellerUtils';

const media = {
    namespaced: true,
    state: {
        list: [],
        mediaFile: null,
        mediaThumbnail: null
    },
    mutations: {
        updateMediaList(state, newList) {
            state.list = newList;
        },
        setMediaFile(state, newObj){
            state.mediaFile = newObj;
        },
        setMediaThumbnail(state, newObj){
            state.mediaThumbnail = newObj;
        }
      
    },
    actions: {
        listAndThumbnails(context){
            return new Promise((resolve) => {
            context.dispatch('list').then((list) => {
                let newList = []
                new Promise((res) => {
                    list.map(it => {
                        it.mediaType = it.mediaType.toLowerCase();
                        return it;
                    });

                    list.forEach((item, index, array) => {
                            item.thumbnail = {
                                "loading": false,
                                "base64": null
                            }
                            if(item.mediaType == 'image'){
                                context.dispatch('getMediaThumbnail', {"mediaId": item.mediaId}).then((r) => {
                                    item.thumbnail = {
                                        "loading": false,
                                        "base64": r.base64.slice(0, 5) + 'image/jpeg;' + r.base64.slice(5)
                                    }
                                })
                                newList.push(item)
                            }else {
                               
                                newList.push(item)
                            }
                            if (index === array.length -1) {
                                res(newList);
                            }
                        });
                    })
                .then((l) => {
                    context.commit('updateMediaList', l);
                    resolve(l);
                })
            });
        });

        },

        list() {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/content/media/list')
                .then(function(response) {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        getMediaFile(context, params){
            context.commit('setMediaFile', null);
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/content/media/getMediaFile', {
                    params: {mediaId: params.mediaId}
                } )
                .then(function(response) {
                    context.commit('setMediaFile', response.data);
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        getMediaThumbnail(context, params){
            context.commit('setMediaThumbnail', null);
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/content/media/getMediaThumbnail', {
                    params: {mediaId: params.mediaId}
                } )
                .then(function(response) {
                    context.commit('setMediaThumbnail', response.data);
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        save(context, mediaObj){
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/content/media/save', mediaObj)
                  .then(response => {
                      context.dispatch('listAndThumbnails');
                      resolve(response);
                  })
                  .catch(error => {
                    reject(error);
                })
              });
        },
        saveImportFile(context, mediaObj){
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/content/media/saveImportFile', mediaObj)
                  .then(response => {
                      resolve(response);
                  })
                  .catch(error => {
                    reject(error);
                })
              });
        },
        uploadFile(context, fileObj){
            let formData = new FormData();
            formData.append('filedata', fileObj);
            formData.append('filename', fileObj.name);
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/content/media/uploadFile'
                    ,formData
                    ,{headers:{'Content-Type': 'multipart/form-data'}})
                  .then(response => {
                    if(utils.checkResponseObjectWithMemeber(response, 'message')) {
                      resolve(response.data.message);
                    }
                    else { 
                        reject();
                    }
                  })
                  .catch(error => {
                    reject(error);
                })
              });
        },
        uploadImportFile(context, fileObj){
            let formData = new FormData();
            formData.append('filedata', fileObj);
            formData.append('filename', fileObj.name);
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/content/media/uploadImportFile'
                    ,formData
                    ,{headers:{'Content-Type': 'multipart/form-data'}})
                  .then(response => {
                    if(utils.checkResponseObjectWithMemeber(response, 'message')) {
                      resolve(response.data.message);
                    }
                    else { 
                        reject();
                    }
                  })
                  .catch(error => {
                    reject(error);
                })
              });
        },
        delete(context, params) {
            return new Promise((resolve, reject) => {
              this._vm.$traveller_http.post('/traveller/restui/content/media/delete', null, {
                headers: {
                  'Content-Type': 'application/json;charset=UTF-8'
                },
                params: {mediaId: params.mediaId}
              })
                .then(response => {
                    context.dispatch('listAndThumbnails');
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            });
          },
    }
}

export default media;